exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ck-heading_heading1{font-size:1.5em}.ck-heading_heading2{font-size:1.3em}.ck-heading_heading3{font-size:1.1em}[class*=ck-heading_]{line-height:21.6px;padding:9.6px}[class*=ck-heading_heading]{font-weight:700}.ck-dropdown.ck-heading-dropdown .ck-dropdown__button .ck-button__label{width:8em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /workspace/ckeditor5/node_modules/css-loader?{"minimize":true}!/workspace/ckeditor5/node_modules/sass-loader/lib/loader.js!../ckeditor5-heading/theme/theme.scss
// module id = 529
// module chunks = 0